module.exports = __webpack_public_path__ + "static/media/textCurto.bfa52560.svg";